import api from "@/utils/backend-api";
const state = {
  from: new Date().toISOString().substr(0, 10),
  until: new Date().toISOString().substr(0, 10),
  fromTime: '00:00',
  untilTime: '23:59',
  worker: '',
  workers: [],
  account: '',
  accounts: [],
  bank: '',
  banks: [],
  banksKeys: {},
  banksIds: [],
};

const getters = {};

const actions = {
  getBanks ({ commit }) {
    api.getData("filters/banks").then(res => {
      commit("setBanks", res.data)
    });
  },
  getWorkers ({ commit }) {
    api.getData("filters/workers").then(res => {
      commit("setWorkers", res.data)
    });
  },
  getAccounts ({ commit }) {
    api.getData("filters/accounts").then(res => {
      commit("setAccounts", res.data)
    });
  },
  setFromDate ({ commit }, from) {
    commit("setFromDate", from);
  },
  setUntilDate ({ commit }, until) {
    commit("setUntilDate", until);
  },
  setFromTime ({ commit }, fromTime) {
    commit("setFromTime", fromTime);
  },
  setUntilTime ({ commit }, untilTime) {
    commit("setUntilTime", untilTime);
  },
  setWorker ({ commit }, worker) {
    commit("setWorker", worker);
  },
  setAccount ({ commit }, account) {
    commit("setAccount", account);
  },
  setBank ({ commit }, bank) {
    commit("setBank", bank);
  },
  setBanks ({ commit }, banks) {
    commit("setBanks", banks);
  },

  flush ({ commit }) {
    commit("flush");
  },
};

const mutations = {
  setFromDate (state, from) {
    state.from = from;
  },
  setUntilDate (state, until) {
    state.until = until;
  },
  setFromTime (state, fromTime) {
    state.fromTime = fromTime;
  },
  setUntilTime (state, untilTime) {
    state.untilTime = untilTime;
  },
  setWorker (state, worker) {
    state.worker = worker;
  },
  setWorkers (state, workers) {
    state.workers = workers;
  },
  setAccount (state, account) {
    state.account = account;
  },
  setAccounts (state, accounts) {
    state.accounts = accounts;
  },
  setBank (state, bank) {
    state.bank = bank;
  },
  setBanks (state, banks) {
    let keys = {};
    for (const item of banks) keys[item.id] = item.name;
    state.banksKeys = keys;
    state.banks = banks;
    state.banksIds = banks.map(x => x.id);
  },
  setBanksKeys (state, keys) {
    state.banksKeys = keys;
  },
  flush (state) {
    state.from = new Date().toISOString().substr(0, 10);
    state.until = new Date().toISOString().substr(0, 10);
    state.worker = '';
    state.bank = '';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/filters.js